import ChatSocketClient, {
    buildChatSocketUrl
} from '@/services/chat/ChatSocketClient';

export default {
    data() {
        return {
            chatSocketClient: null,
            chatSocketMethod: null,
            socketConnected: false,
            activeSocketId: ''
        };
    },

    created() {
        this.createChatSocketClient();
    },

    methods: {
        createChatSocketClient() {
            if (this.chatSocketClient) {
                return;
            }

            this.chatSocketClient = new ChatSocketClient({
                createUrl: (socketId) => {
                    return this.buildWebSocketUrl(socketId);
                },

                onMessage: (event) => {
                    this.handleSocketMessage(event);
                },

                onStateChange: (socketState) => {
                    this.chatSocketMethod =
                        socketState.socket;

                    this.socketConnected =
                        socketState.connected;

                    this.activeSocketId =
                        socketState.socketId;
                },

                onError: (error) => {
                    console.error(
                        'Chat WebSocket error:',
                        error
                    );
                },

                isActive: () => {
                    return this.componentActive !== false;
                }
            });
        },

        buildWebSocketUrl(socketId) {
            const configuredBaseUrl =
                process.env.VUE_APP_WEBSOCKET_BASE_URL ||
                '';

            const token =
                typeof window !== 'undefined' &&
                window.localStorage
                    ? window.localStorage.getItem('token')
                    : '';

            return buildChatSocketUrl(
                configuredBaseUrl,
                socketId,
                token
            );
        },

        initWebSocket(socketId) {
            if (!this.chatSocketClient) {
                this.createChatSocketClient();
            }

            return this.chatSocketClient.connect(
                socketId
            );
        },

        isChatSocketOpen() {
            return Boolean(
                this.chatSocketClient &&
                this.chatSocketClient.isOpen()
            );
        },

        sendChatSocketPayload(payload) {
            return Boolean(
                this.chatSocketClient &&
                this.chatSocketClient.send(payload)
            );
        },

        // Compatibility wrappers for existing callers.
        startSocketPing(socket) {
            if (this.chatSocketClient && socket) {
                this.chatSocketClient.startPing(
                    socket
                );
            }
        },

        clearSocketPing() {
            if (this.chatSocketClient) {
                this.chatSocketClient.clearPing();
            }
        },

        reconnect(socketId) {
            if (this.chatSocketClient && socketId) {
                this.chatSocketClient.scheduleReconnect(
                    String(socketId)
                );
            }
        },

        closeExistingSocket() {
            if (this.chatSocketClient) {
                this.chatSocketClient.close(
                    'Chat room closed'
                );
            }
        },

        destroyChatSocketClient() {
            if (!this.chatSocketClient) {
                return;
            }

            this.chatSocketClient.destroy();
            this.chatSocketClient = null;
            this.chatSocketMethod = null;
            this.socketConnected = false;
            this.activeSocketId = '';
        },

        handleSocketMessage(event) {
            this.renderLiveMessageMethod(event);
        }
    }
};
